import React from "react";
import ReactDOM from "react-dom";
import LogRocket from 'logrocket';

import Frontpage from "./page/Frontpage/Frontpage";
import "./page/Frontpage/theme.css";
import "./configs/i18next"

LogRocket.init('u8pigf/ianmostarcom');

LogRocket.identify('001', {
    name: 'Ian Mostar',
    email: 'ianmostar@gmail.com'
  });
ReactDOM.render(<Frontpage />, document.getElementById("root"));
